import { graphql } from "relay-runtime"

const chTimeToTreatQuery = graphql`
  query chTimeToTreatQuery {
    timesToTreatByPointOfCare: ch_timesToTreatByPointOfCare {
      pointOfCare
      timesToTreat
    }
  }
`

export { chTimeToTreatQuery as ch_TimeToTreatQuery }
